'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const Route = require('common/route');
const ElementAction = require('system/domain/action/element');
const DiagramRepository = require('system/domain/repository/diagram');
const ElementRepository = require('system/domain/repository/element');
const RelationTypeRepository = require('system/domain/repository/relation-type');
const Diagrams = require('system/domain/value/diagrams');
const RemoteLinkListViewTemplate = require('system/ui/template/detail/remote-link-list.hbs');
const RemoteLinkItemViewTemplate = require('system/ui/template/detail/remote-link-item.hbs');
const RemoteLinkItemEditViewTemplate = require('system/ui/template/detail/remote-link-item-edit.hbs');

const RemoteLinkItemView = Mn.View.extend({
    tagName: 'li',
    className: 'remote-link-item list-item',
    template: RemoteLinkItemViewTemplate,

    initialize: function(params) {
        this.node = params.node;
        this._context = this.getOption('context');
        if(this.model.get('source') == this.node){
            this.anotherNode = this.model.get('target');
        } else if(this.model.get('target') == this.node) {
            this.anotherNode = this.model.get('source');
        }
        this.listenTo(this.anotherNode, 'change', this.render);
        this.listenTo(this.model, 'change', this.render);
    },

    serializeData: function() {
        let target = true;
        let source = false;
        if(this.model.get('source') == this.node){
            target = false;
            source = true;
        }

        const another = this.anotherNode;
        const diagrams =
            DiagramRepository.getDiagrams({
                context: this._context
            })
                .chain()
                .filter(function(d) {
                    return d.hasElement(another);
                })
                .map(function(d) {
                    const j = d.toJSON();
                    j.url = Route.urlFor(
                            'path:diagram', d.idParams())
                        + Route.urlFor(
                            'diagram:element', {id: another.id});
                    return j;
                })
                .value();

        const type = this.model.get('type');
        const typeStr = this.model.i18nType();
        return {
            type: type,
            typeStr: typeStr,
            target: target,
            source: source,
            node: this.anotherNode.toJSON(),
            diagrams: diagrams
        };
    },

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
        $.material.init();
    }
});

const RemoteLinkItemEditView = RemoteLinkItemView.extend({
    template: RemoteLinkItemEditViewTemplate,
    events: {
        'change .remote-link-item-type-select': 'selectType',
        'click .remove': '_remove'
    },

    serializeData: function() {
        const j = this.constructor.__super__.serializeData.call(this);
        j.types = {};
        _.each(Diagrams.getLinks(
            this.model.get('source').get('type'),
            this.model.get('target').get('type')), function(type) {
            j.types[type] = RelationTypeRepository.getRelationTypes().get(type).toJSON();
        });
        j.types[j.type] = RelationTypeRepository.getRelationTypes().get(j.type).toJSON();
        j.types[j.type].selected = true;
        return j;
    },

    selectType: function() {
        const type = this.$('.remote-link-item-type-select option:selected').val();
        this.model.set('type', type);
        ElementAction.updateRemoteLink({
            context: this._context,
            link: this.model.toJSON()
        });
    },

    _remove: function() {
        ElementAction.deleteRemoteLink({
            context: this._context,
            link: this.model.toJSON()
        })
            .done(_.bind(function() {
                this.remove();
            }, this));
    }
});

const RemoteLinkListView = Mn.CompositeView.extend({
    template: RemoteLinkListViewTemplate,
    childViewContainer: '.remote-link-list',
    childView: function() {
        if(this.edit) {
            return RemoteLinkItemEditView;
        } else {
            return RemoteLinkItemView;
        }
    },
    childViewOptions: function() {
        return {
            node: this.node,
            context: this._context
        };
    },

    /**
     * コミットの一覧を表示するための View。
     *
     * @constructs
     */
    initialize: function(params) {
        this.edit = params.edit;
        this.node = params.node;
        this._diagram = params.diagram;
        this._context = this.getOption('context');
        this.collection = ElementRepository.getLinks({
            context: this._context
        });
    },

    filter: function (child) {
        return !this._diagram.hasLink(child) &&
            !child.get('deleted') &&
            (child.get('source') == this.node ||
            child.get('target') == this.node);
    }
});

module.exports = RemoteLinkListView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/remote-link-list.js